export default __webpack_public_path__ + "static/media/spooky_hill_background_m2.bd411611.jpg";